// The PHP entry point places this public JSON alongside the server-rendered HTML.
// Read it on the first page mount instead of replacing crawlable content with a
// loading screen and depending on a second cross-origin request for that content.
const loadedAt = Date.now();
const normalizePath = (path) => path.replace(/\/+$/, "") || "/";
const listingQuery = (search) => {
  const query = new URLSearchParams(search);
  return {
    page: String(Math.max(1, Math.min(10000, parseInt(query.get("page"), 10) || 1))),
    q: query.get("q") || "",
    category: query.get("category") || "",
    sort: query.get("sort") || "newest",
  };
};

export function readBlogBootstrap(kind) {
  // Do not reuse the initial document indefinitely after SPA navigation.
  if (Date.now() - loadedAt > 60000) return null;
  try {
    const payload = JSON.parse(document.getElementById("instaport-blog-data")?.textContent || "null");
    if (!payload || payload.kind !== kind ||
        normalizePath(payload.pathname) !== normalizePath(window.location.pathname)) return null;
    if (kind === "article") {
      const blog = payload.data;
      if (!blog || payload.pathname !== `/${blog.slug}/${blog.blogId}` ||
          !Array.isArray(blog.blocks) || !Array.isArray(blog.tags) || !blog.title) return null;
    } else if (kind === "listing") {
      const query = listingQuery(window.location.search);
      if (Object.keys(query).some(key => query[key] !== payload.query?.[key]) ||
          !Array.isArray(payload.data?.items) || !Array.isArray(payload.data?.categories)) return null;
    } else return null;
    return payload.data;
  } catch (_) {
    return null; // Older backend versions and development still use the public API.
  }
}
